"use strict";
module.exports = require('../../module.compiled').vendored['contexts'].HtmlContext;

//# sourceMappingURL=html-context.js.map